import Link from "next/link";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";

export function Pagination({
  pages,
  activePage,
}: {
  pages: { url: string; pageId: number }[];
  activePage: number;
}) {
  if (pages.length <= 1) return <></>;

  let croppedPages;
  if (activePage <= 3) {
    croppedPages = pages.slice(0, 7);
  } else if (activePage > pages.length - 3) {
    croppedPages = pages.slice(-7);
  } else {
    croppedPages = pages.slice(activePage - 4, activePage + 3);
  }

  const prevPage = pages[pages.findIndex((page) => page.pageId === activePage) - 1];
  const nextPage = pages[pages.findIndex((page) => page.pageId === activePage) + 1];

  return (
    <div className="g-pager">
      {activePage !== pages[0].pageId && prevPage && (
        <Link className="g-pager-link mode-icon" href={prevPage.url}>
          <MdKeyboardArrowLeft size={24} />
        </Link>
      )}
      {croppedPages.map((page) => (
        <Link
          href={page.url}
          key={page.pageId}
          className={"g-pager-link" + (activePage === page.pageId ? " mode-active" : "")}
        >
          {page.pageId}
        </Link>
      ))}
      {activePage !== pages[pages.length - 1].pageId && nextPage && (
        <Link className="g-pager-link mode-icon" href={nextPage.url}>
          <MdKeyboardArrowRight size={24} />
        </Link>
      )}
    </div>
  );
}
